module.exports = __webpack_public_path__ + "img/bg.0103cb75.png";